export default class StringUtils {
  public static removeSpaces = (val: string) => {
    return val.replace(/\s/g, '')
  }

  public static removeZeroWidthChars = (val: string) => {
    return val.replace(/[\u200B-\u200D\uFEFF]/g, '')
  }
}
